"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var image_1 = __importDefault(require("next/image"));
var react_1 = __importStar(require("react"));
var Dropdown_1 = require("./Dropdown");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Profile = function (_a) {
    var playerName = (0, swr_hooks_1.usePlayerName)();
    var isLoading = (0, swr_hooks_1.usePlayerStatus)().isLoading;
    var _b = (0, react_1.useState)(false), isProfileOpen = _b[0], setIsProfileOpen = _b[1];
    var handleClickProfileInfo = (0, react_1.useCallback)(function () { return setIsProfileOpen(!isProfileOpen); }, [setIsProfileOpen, isProfileOpen]);
    var closeProfileDropdown = (0, react_1.useCallback)(function () { return setIsProfileOpen(false); }, [setIsProfileOpen]);
    var profileRef = (0, react_1.useRef)(null);
    (0, apps_shared_1.useClickOutside)(closeProfileDropdown, profileRef);
    if (isLoading)
        return null;
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " ").concat(isProfileOpen ? styles_module_scss_1.default.profileOpened : ''), ref: profileRef },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.profileInfo, onClick: handleClickProfileInfo },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.userName }, playerName),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.icon },
                react_1.default.createElement(image_1.default, { alt: "arrow", src: isProfileOpen
                        ? '/img/icons/dropdown-arrow-round-opened.svg'
                        : '/img/icons/dropdown-arrow-round.svg', width: 12, height: 12 }))),
        isProfileOpen && (react_1.default.createElement(react_1.Suspense, { fallback: false },
            react_1.default.createElement(Dropdown_1.ProfileDropdown, { closeProfileDropdown: closeProfileDropdown })))));
};
exports.default = Profile;
